(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-upgrade-to-subscription]');
    if (!btn) return;
    e.preventDefault();

    const sellingPlanId = btn.getAttribute('data-selling-plan-id');
    if (!sellingPlanId) return;

    const allButtons = document.querySelectorAll('[data-cart-upgrade-to-subscription]');
    allButtons.forEach(b => { b.disabled = true; });
    const originalLabel = btn.textContent;
    btn.textContent = 'Upgrading...';

    try {
      let cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartRes.ok) throw new Error('cart fetch failed: ' + cartRes.status);
      let cart = await cartRes.json();

      const processedKeys = new Set();
      let iterations = 0;
      const maxIterations = 50;

      while (iterations < maxIterations) {
        const oneTime = cart.items.find(item => !item.selling_plan_allocation);
        if (!oneTime) break;

        if (processedKeys.has(oneTime.key)) {
          throw new Error('line key reprocessed: ' + oneTime.key);
        }
        processedKeys.add(oneTime.key);

        const changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: oneTime.key,
            quantity: oneTime.quantity,
            selling_plan: parseInt(sellingPlanId, 10)
          })
        });
        if (!changeRes.ok) throw new Error('upgrade failed: ' + changeRes.status);
        cart = await changeRes.json();
        iterations++;
      }

      const sectionRes = await fetch('/?sections=cart-drawer');
      const sectionData = await sectionRes.json();

      if (window.eventBus && typeof window.eventBus.emit === 'function') {
        window.eventBus.emit('update:cart:drawer', { sections: sectionData });
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error('[SC cart upgrade] Error:', err);
      allButtons.forEach(b => { b.disabled = false; });
      btn.textContent = originalLabel;
      alert('Could not upgrade. Please try refreshing.');
    }
  });
})();
